import { ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX } from '@atlassian/conversation-assistant-content-transformer/utils/actionable-follow-ups';

/**
 * Component key for actionable follow-up questions. Combined with the streaming
 * counter (`${key}-N`) it produces status localIds prefixed with
 * `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`.
 */
export const ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY: string =
	ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX.replace(/-$/, '');
